<template>
  <div class="barCon">
    <div class="header pr">
      <!-- 安全规则管理 -->
      <header-tag :title="'安全中心网吧列表'"></header-tag>
      <div class="search pa clearfix topCenter" >
        <!-- <Input v-model="barName" autocomplete="off">
        <Select v-model="searchType" slot="prepend" style="width: 120px">
          <Option value="barName">网吧名字</Option>
          <Option value="barId">网吧ID</Option>
          <Option value="ip">网关IP</Option>
          <Option value="gateMac">网关MAC</Option>
        </Select>
        <Button slot="append" icon="ios-search" @click="searchFn"></Button>
        </Input> -->
        <!-- <Select class="fl" v-model="searchType" slot="prepend" style="width: 120px">
          <Option value="barId">网吧ID</Option>
          <Option value="barName">网吧名字</Option>
          <Option value="ip">网关IP</Option>
          <Option value="gateMac">网关MAC</Option>
        </Select> -->
        <Select class="fl" v-model="secGroupTypeId" placeholder="请选择安全组类别" slot="prepend" style="width: 160px">
          <Option value="0">安全组分类</Option>
          <Option v-for="(item,index) in secGroupTypeData" :key="index" :value="item.id">{{ item.securityTypeName }}</Option>
        </Select>
        <Select class="fl" v-model="secGroupId" slot="prepend"  placeholder="请选择安全组"  style="width: 160px">
          <Option value="0">全部安全组</Option>
          <Option v-for="(item,index) in listSecurityGroupData" :key="index" :value="item.id">{{ item.securityName }}</Option>
        </Select>
        <input type="text" style="width: 260px;" v-on:keyup.enter="searchFn" placeholder="请输入网吧ID或网吧名字或网关IP或网关MAC" onfocus="this.removeAttribute('readonly');" readonly class="fl" v-model="barName"
          autocomplete="off">
        <Button slot="append" class="fl" icon="ios-search"  v-on:keyup.enter="searchFn"  @click="searchFn"></Button>
      </div>
    </div>
    <div class="pa loadingCon" v-if="loading">
      <no-data style="height:auto;padding-top:20px;padding-bottom:20px;" :loading="true">加载中</no-data>
    </div>
    <!-- 表格部分 -->
    <div class="table-content pr" style="font-size:12px;">
      <Table border stripe :columns="columns1" :data="data1"
        @on-selection-change="selectFn">
        <template slot-scope="{row,index}" slot="securitySwitch">
          <switchcCom :value="row.securitySwitch" @change="securitySwitchFn(row, index)">开启</switchcCom>
        </template>
        <!-- <template slot-scope="{row,index}" slot="exeSwitch">
          <switchcCom :value="row.exeSwitch" @change="exeSwitchFn(row, index)">开启</switchcCom>
        </template> -->

        <template slot-scope="{row,index}" slot="logSwitch">
          <switchcCom :value="row.logSwitch" @change="logSwitchFn(row, index)">开启</switchcCom>
        </template>
        <template slot-scope="{row,index}" slot="action">
          <Button size="small" type="primary" class="f12" style="margin:0 4px 0 0;" @click="gotoFn(row)">客户机及调试管理</Button>
          <Button  size="small" type="primary"  style="margin:0 4px 0 0;"  @click.stop="editorFn(row, index)">改名</Button>
          <Dropdown placement="bottom-start"  :transfer ="true">
              <Button type="success" size="small" >
                  更多操作
                  <Icon type="ios-arrow-down"></Icon>
              </Button>
              <Dropdown-menu slot="list" >
                  <!-- <Dropdown-item>
                    <div  @click="taskFn(row, 1)">DLL注入任务管理</div>
                  </Dropdown-item> -->
                  <Dropdown-item>
                    <div  @click="taskFn(row, 2)">开机通道任务管理</div>
                  </Dropdown-item>
                  <!-- <Dropdown-item>
                    <div  @click.stop="taskFn(row, 3)">DLL注入任务管理</div>
                  </Dropdown-item>
                  <Dropdown-item>
                    <div  @click.stop="taskFn(row, 2)">开机通道任务管理</div>
                  </Dropdown-item> -->
                  <Dropdown-item >
                    <div  @click="looDir(row.logDir)">查看日志路径</div>
                  </Dropdown-item>
                  <Dropdown-item >
                    <div @click="delFn(row.barId)">删除</div>
                  </Dropdown-item>
              </Dropdown-menu>
          </Dropdown>
        </template>
      </Table>
      <div class="tal" style="margin-top:10px;">
        <Button class="fl" type="warning" style="margin:0 4px 0 0;" :disabled="selectVal.length == 0" @click="delBar">删除网吧 <b
            v-if="selectVal.length > 0">(已选{{ selectVal.length
            }})</b></Button>
        <Button class="fl"  type="primary" style="margin:0 4px 0 0;" :disabled="selectVal.length == 0" @click="batchSwitchSecurity(1)">防护全开 <b
            v-if="selectVal.length > 0">(已选{{ selectVal.length
            }})</b></Button>
             <Button class="fl"  type="primary" style="margin:0 4px 0 0;" :disabled="selectVal.length == 0" @click="batchSwitchSecurity(0)">防护全关<b
            v-if="selectVal.length > 0">(已选{{ selectVal.length
            }})</b></Button>
            <!-- <Button class="fl"  type="info" style="margin:0 4px 0 0;" :disabled="selectVal.length == 0" @click="batchSwitchExeSwitch(1)">开机通道全开 <b
            v-if="selectVal.length > 0">(已选{{ selectVal.length
            }})</b></Button>
            <Button class="fl"  type="info" style="margin:0 4px 0 0;" :disabled="selectVal.length == 0" @click="batchSwitchExeSwitch(0)">开机通道全关 <b
            v-if="selectVal.length > 0">(已选{{ selectVal.length
            }})</b></Button> -->
        <Page :total="total" class="tar" :page-size="size" show-sizer :page-size-opts="[50,100, 300, 500, 1000]" show-total
          @on-change="changeFn" @on-page-size-change="changeSizeFn" />
      </div>
    </div>
    <edit-bar-info></edit-bar-info>
    <div class="mackCon pf pr" v-if="isEditor">
      <div class="inMaskCon pa">
        <div class="title tal pr f14">修改网吧名称 <i class="closeIncon f30 pa" @click="isEditor = false">×</i></div>
        <div class="bodyCon">
          <Form :label-width="80">
            <Form-item label="网吧名称">
              <Input placeholder="请输入" v-model="curData.barName" style="width:300px;"></Input>
            </Form-item>
          </Form>
        </div>
        <div class="footCon tar">
          <Button @click="isEditor = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary" @click="updateBarName">保存</Button>
        </div>
      </div>
    </div>
    <dllList ref="taskList"/>
  </div>
</template>
<script>
import DefaultModal from '_c/modals/defaultModal'
import switchcCom from '_c/switch/switch'
import HeaderTag from '_c/tagTitle/headerTag'
import { getPageOfBar, delBar, switchBarLog, updateBarName } from '@/requests/selfClient'
import { updateBarInfo } from '@/requests/bar'
import EditBarInfo from '../../barManager/modals/editBarInfo.vue'
import { protectionOpenOrClose } from '@/requests/securityCenter'
import NoData from '_c/noData/noData'
import dllList from '_c/task/dllList'
import {switchBarExeStatus} from '@/requests/task'
import {secGroupTypeList, listSecurityGroup, batchSwitchSecurity, batchSwitchExeSwitch} from '@/requests/secGroup'
export default {
  components: {
    HeaderTag,
    EditBarInfo,
    switchcCom,
    NoData,
    DefaultModal,
    dllList
  },
  data () {
    return {
      loading: false,
      isShowDetail: false,
      isEditor: false,
      searchType: 'barId',
      columns1: [
        {
          type: 'selection',
          width: 40,
          align: 'center'
        },
        {
          title: '网吧ID',
          key: 'barId',
          sortable: true,
          width: 70,
        },
        {
          title: '网吧名称',
          key: 'barName',
          width: 150,
          align: 'center',
          sortable: true,
          ellipsis: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.data1[params.index].barName,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.data1[params.index].barName)
            ])
          }
        },
        {
          title: '内网网关IP',
          key: 'ip',
          width: 120,
          align: 'left',
          sortable: true,
        },
        {
          title: '内网网关MAC',
          key: 'gateMac',
          width: 130,
          align: 'right',
          sortable: true,
        },
        {
          title: '客户端版本',
          key: 'clientVer',
          width: 90,
          align: 'center',
          sortable: true,
        },
        {
          title: '安全组分类',
          key: 'securityTypeName',
          sortable: true,
          align: 'left',
          width: 120,
        },
        {
          title: '安全组名称',
          key: 'securityName',
          align: 'left',
          ellipsis: true,
          sortable: true,
          width: 130,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.data1[params.index].securityName,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.data1[params.index].securityName)
            ])
          },
        },
        {
          title: '客户机总数',
          key: 'clientCount',
          sortable: true,
          align: 'center',
          width: 90,
        },
        {
          title: '今日开机数',
          key: 'todayCount',
          sortable: true,
          width: 90,
          align: 'center',
        },
        {
          title: '昨日开机数',
          key: 'yesterdayCount',
          sortable: true,
          width: 90,
          align: 'center',
        },
        {
          title: '前日开机数',
          key: 'beforeYesterdayCount',
          sortable: true,
          align: 'center',
          width: 90,
        },
        {
          title: '防护开关',
          key: 'securitySwitch',
          slot: 'securitySwitch',
          align: 'center',
          width: 90,
          fixed: 'right',
          sortable: true,

        },
        // {
        //   title: '开机通道开关',
        //   slot: 'exeSwitch',
        //   align: 'center',
        //   width: 90,
        //   fixed: 'right',
        //   sortable: true,

        // },
        // {
        //   title: '拦截记录',
        //   key: 'logSwitch',
        //   width: 70,
        //   slot: 'logSwitch',
        //   align: 'center',
        // },
        {
          title: '操作',
          key: 'action',
          slot: 'action',
          width: 260,
          align: 'center',
          fixed: 'right'
        },
      ],
      columns: [
        {
          type: 'selection',
          width: 40,
          align: 'center'
        },
        {
          title: '网吧ID',
          key: 'barId',
          sortable: true,
          width: 70,
        },
        {
          title: '网吧名称',
          key: 'barName',
          width: 150,
          align: 'center',
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.data1[params.index].barName,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.data1[params.index].barName)
            ])
          }
        },

        {
          title: '内网网关IP',
          key: 'ip',
          width: 120,
          align: 'left',
          sortable: true,
        },
        {
          title: '内网网关MAC',
          key: 'gateMac',
          width: 130,
          align: 'right',
          sortable: true,
        },
        {
          title: '客户端版本',
          key: 'clientVer',
          width: 90,
          align: 'center',
          sortable: true,
        },
        {
          title: '安全分组名称',
          key: 'securityName',
          align: 'left',
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.data1[params.index].securityName,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.data1[params.index].securityName)
            ])
          },
        },
        {
          title: '安全组分类',
          key: 'securityTypeName',
          sortable: true,
          align: 'left',
          width: 120,
        },
        {
          title: '客户机总数',
          key: 'clientCount',
          sortable: true,
          width: 90,
          align: 'center',
        },
        {
          title: '今日开机数',
          key: 'todayCount',
          sortable: true,
          width: 90,
          align: 'center',
        },
        {
          title: '昨日开机数',
          key: 'yesterdayCount',
          sortable: true,
          width: 90,
          align: 'center',
        },
        {
          title: '前日开机数',
          key: 'beforeYesterdayCount',
          sortable: true,
          width: 90,
          align: 'center',

        },

        {
          title: '防护开关',
          key: 'securitySwitch',
          slot: 'securitySwitch',
          align: 'center',
          width: 90,
          fixed: 'right',
          sortable: true,

        },
        // {
        //   title: '开机通道开关',
        //   slot: 'exeSwitch',
        //   align: 'center',
        //   width: 90,
        //   fixed: 'right',
        //   sortable: true,

        // },
        {
          title: '操作',
          key: 'action',
          slot: 'action',
          align: 'center',
          width: 260,
          fixed: 'right'
        },
      ],
      data1: [],
      size: 50,
      current: 1,
      total: 0,
      barId: '',
      barName: '',
      groupId: '',
      selectVal: [],
      curData: '',
      curIndex: 0,
      btnLoading: false,
      secGroupTypeData: [],
      secGroupTypeId: '0',
      listSecurityGroupData: [],
      secGroupId: '0'
    }
  },
  watch: {
    barName () {
      if (this.barName == '') {
        this.getPageOfBar()
      }
    },
    secGroupTypeId() {
      this.current = 1
      this.getPageOfBar()
      this.listSecurityGroup()
    },
    secGroupId() {
      this.current = 1
      this.getPageOfBar()
    }
  },
  mounted () {
    this.getPageOfBar()
    this.secGroupTypeList()
    this.listSecurityGroup()
  },
  methods: {
    batchSwitchSecurity(val) {
      let ids = []
      this.selectVal.forEach(el => {
        ids.push(el.barId)
      })
      let txt = '关闭'
      if (val == 1) {
        txt = '开启'
      }
      this.$Modal.confirm({
        title: `确定批量${txt}这些网吧的防护吗？`,
        onOk: async () => {
          let res = await batchSwitchSecurity({
            ids: ids,
            status: val
          })
          if (res.code == 200) {
            this.getPageOfBar()
            this.selectVal = []
          }
        }
      })
    },
    batchSwitchExeSwitch(val) {
      let ids = []
      this.selectVal.forEach(el => {
        ids.push(el.barId)
      })
      let txt = '关闭'
      if (val == 1) {
        txt = '开启'
      }
      this.$Modal.confirm({
        title: `确定批量${txt}这些网吧的开机通道吗？`,
        onOk: async () => {
          let res = await batchSwitchExeSwitch({
            ids: ids,
            status: val
          })
          if (res.code == 200) {
            this.getPageOfBar()
            this.selectVal = []
          }
        }
      })
    },
    async secGroupTypeList() {
      let res = await secGroupTypeList()
      if (res.code == 200) {
        this.secGroupTypeData = res.data
      }
    },
    async listSecurityGroup() {
      let secGroupTypeId = ''
      if (this.secGroupTypeId != 0) {
        secGroupTypeId = this.secGroupTypeId
      }
      let res = await listSecurityGroup(
        {
          groupTypeId: secGroupTypeId
        }
      )
      if (res.code == 200) {
        this.listSecurityGroupData = res.data
      }
    },
    taskFn(val, index) {
      this.$refs.taskList.visible = true
      this.$refs.taskList.type = index

      this.$refs.taskList.curData = val
    },
    looDir (val) {
      this.$Modal.info({
        title: '日志路径',
        content: val
      });
    },
    gotoFn (val) {
      console.log(val)
      this.$router.push({
        path: '/home/securityCenter/index/client',
        query: { barId: val.barId, barName: val.barName, logDir: val.logDir }
      })
    },
    editorFn (val, index) {
      this.curIndex = index
      this.curData = val
      this.isEditor = true
    },
    async updateBarName () {
      this.btnLoading = true
      let res = await updateBarName({
        barId: this.curData.barId,
        barName: this.curData.barName
      })
      this.btnLoading = false
      if (res.code == 200) {
        this.data1[this.curIndex].barName = this.curData.barName
        this.$Notice.success({
          title: res.msg
        })

        this.isEditor = false
      } else {
        this.$Notice.error({
          title: res.msg
        })
      }
    },
    delFn (id) {
      this.$Modal.confirm({
        title: '确定删除该网吧吗?',
        content: '删除后，会重新生成新的barId和网吧名',
        onOk: async () => {
          let res = await delBar({
            ids: id
          })
          if (res.code == 200) {
            if (res.data && res.data.length > 0) {
              this.$Notice.error({
                title: '当前网吧有机器正在进行调试，不能删除！'
              })
            }
            this.getPageOfBar()
          } else {
            this.$Message.error(res.msg);
          }
        },
      })
    },

    async delBar () {
      let ids = ''
      this.selectVal.forEach(el => {
        if (ids != '') {
          ids += ',' + el.barId
        } else {
          ids += el.barId
        }
      })
      this.$Modal.confirm({
        title: '确定批量删除网吧吗？',
        content: '删除后，客户端重新上线会生成新的网吧ID，网吧名称会暂时以网关MAC命名',
        onOk: async () => {
          let res = await delBar({
            ids: ids
          })
          if (res.code == 200) {
            this.getPageOfBar()
          }
        }
      })
    },
    inputControl (e) {
      e.target.readOnly = false
    },
    logSwitchFn (row, index) {
      let val
      if (row.logSwitch) {
        val = 0
      } else {
        val = 1
      }
      this.switchBarLog(row.barId, val, index)
    },
    async switchBarLog (id, val, index) {
      let res = await switchBarLog({
        barId: id,
        logSwitch: val
      })
      if (res.code == 200) {
        this.data1[index].logSwitch = !this.data1[index].logSwitch
        this.current = 1
        this.getPageOfBar()
        if (val) {
          this.$Notice.success({
            title: '拦截记录开启成功'
          })
        } else {
          this.$Notice.success({ title: '拦截记录关闭成功' })
        }
      } else {
        this.current = 1
        this.getPageOfBar()
        if (val) {
          this.$Notice.error({
            title: '拦截记录开启失败'
          })
        } else {
          this.$Notice.error({ title: '拦截记录关闭失败' })
        }
      }
    },
    async exeSwitchFn(row, index) {
      let val
      if (row.exeSwitch) {
        val = 0
      } else {
        val = 1
      }
      let res = await switchBarExeStatus({
        status: val,
        barId: row.barId
      })
      if (res.code == 200) {
        this.getPageOfBar()
      } else {
        this.$Message.error(res.msg)
      }
    },
    securitySwitchFn (row, index) {
      let val
      if (row.securitySwitch) {
        val = 0
      } else {
        val = 1
      }
      this.protectionOpenOrClose(row.barId, val, index)
    },
    async protectionOpenOrClose (id, val, index) {
      let res = await protectionOpenOrClose({
        barId: id,
        protectionStatus: val,
      })
      if (res.code == 200) {
        this.data1[index].securitySwitch = !this.data1[index].securitySwitch
        this.current = 1
        this.getPageOfBar()
        if (val) {
          this.$Notice.success({
            title: '防护开启成功'
          })
        } else {
          this.$Notice.success({ title: '防护关闭成功' })
        }
      } else {
        this.current = 1
        this.getPageOfBar()
        if (val) {
          this.$Notice.error({
            title: '防护开启失败'
          })
        } else {
          this.$Notice.error({ title: '防护关闭失败' })
        }
      }
    },
    selectFn (val) {
      this.selectVal = val
      console.log(val)
    },
    async updateBarInfo () {
      let res = await updateBarInfo({
        barId: this.barId,
        barName: this.barName,
        groupId: this.groupId,
        // barCityid: this.$refs.citySelector.getRes()
      })
      console.log(res)
    },
    changeSizeFn (val) {
      this.size = val
      this.getPageOfBar()
    },
    changeFn (val) {
      this.current = val
      console.log(val)
      this.getPageOfBar()
    },
    searchFn () {
      this.getPageOfBar()
    },
    async getPageOfBar () {
      this.data1 = []
      this.loading = true
      let json = {}; let val = ''
      var ipReg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/
      var temp = /[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}/;
      let exp = /^[+-]?\d*(\.\d*)?(e[+-]?\d+)?$/
      let isIp = ipReg.test(this.barName.trim())
      let isMac = temp.test(this.barName.trim())
      console.log(isMac)
      let isBarId = exp.test(this.barName.trim())
      if (isBarId && this.barName.trim().length == 8) {
        this.searchType = 'barId'
      }
      if (isIp) {
        this.searchType = 'ip'
      }
      if (isMac) {
        this.searchType = 'gateMac'
      }
      if (this.barName.trim().length != '8' && !isIp && !isMac) {
        this.searchType = 'barName'
      }
      json[this.searchType] = this.barName.trim()
      val = encodeURIComponent(JSON.stringify(json))
      // if(this.barName != ''){
      //   val = encodeURIComponent(JSON.stringify(json))
      // }else{
      //   val = ''
      // }
      let secGroupTypeId = ''; let secGroupId = ''
      if (this.secGroupTypeId != 0) {
        secGroupTypeId = this.secGroupTypeId
      }
      if (this.secGroupId != 0) {
        secGroupId = this.secGroupId
      }

      let data = {
        num: this.current,
        size: this.size,
        key: val,
        secGroupTypeId: secGroupTypeId,
        secGroupId: secGroupId
      }
      let res = await getPageOfBar(data)
      this.loading = false
      if (res.code == 200) {
        if (res.data != null) {
          this.total = Number(res.data.total)
          this.data1 = res.data.records
        }
      }
    },
    show (index) {
      console.log(index)
      // this.$Modal.info({
      //   title: 'User Info',
      //   content: `Name：${this.data6[index].name}<br>Age：${this.data6[index].age}<br>Address：${this.data6[index].address}`
      // })
      // this.isShowDetail = true
    },
    // remove(index) {
    //   console.log(index)
    //   this.isShowDetail = true
    // }
  }
}
</script>
<style lang="scss" scoped>
.header {
  padding-left: 30px;
  text-align: left;
  position: relative;
  z-index: 10;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}

.right {
  float: right;
  padding-right: 20px;

  a {
    margin-left: 6px;
    line-height: normal;
  }
}

.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 12px !important;

  .ivu-table-header thead tr {
    font-size: 12px !important;
  }
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;

  >div {
    display: inline-block;
  }
}

.search {
  display: inline-block;
  height: 30px;

  input {
    width: 200px;
    line-height: 30px;
    text-indent: 10px;
    border: 1px solid #eee;
  }

  margin-left: 20px;

  a {
    height: 32px;
    background: #eee;
    width: 32px;
    text-align: center;
    line-height: 32px;
    top: 12px;
  }
}

.loadingCon {
  width: 100%;
  height: 100%;
  background: rgba($color: #fff, $alpha: .3);
  z-index: 9;
}
</style>
<style lang="scss">
.barCon {
  .ivu-table-wrapper{
    overflow: inherit !important;
  }
  .ivu-tooltip {
    width: 120px !important;
    height: 35px;
    line-height: 40px;
    overflow: hidden;
  }

  .ivu-tooltip .ivu-tooltip-rel {
    width: 120px !important;
  }

  .ivu-table-cell {
    padding: 0 4px !important;
  }

  .weui-switch {
    margin-left: 4px;
  }

  .lookDir {
    height: 24px;

    .ivu-tooltip-rel {
      height: 24px;
      position: absolute;
      left: 0;
      top: 9px;
    }
  }

  .ivu-table-header thead tr th {
    height: 100% !important;
    padding: 8px 0;
  }
}
</style>